import * as signalR from "@microsoft/signalr";
import { actionTypes } from "app/modules/auth";
import { setAuthAPIUnavailable } from "app/system/apiStatus/APIStatusSlice";
import { setupCommonSignalRFunctions } from "./Notifications/SignalRNotificationHelpers";

/* eslint @typescript-eslint/no-explicit-any: 0 */

let connection: signalR.HubConnection;
let initialised: boolean = false;
let authenticated: boolean = false;
let reconnectIntervalID: ReturnType<typeof setInterval> | null = null;
let authenticateIntervalID: ReturnType<typeof setInterval> | null = null;

const RECONNECT_INTERVAL = 1000 * 10; // 10 seconds
const AUTHENTICATE_INTERVAL = 1000; // 1 second

const startSignalRConnection = (dispatch: (arg0: any) => any) =>
  connection
    .start()
    .then(() => {
      dispatch(setAuthAPIUnavailable(false));

      if (reconnectIntervalID) {
        clearInterval(reconnectIntervalID);
      }
    })
    .catch(() => {
      dispatch(setAuthAPIUnavailable(true));

      if (!reconnectIntervalID) {
        reconnectIntervalID = setInterval(startSignalRConnection, RECONNECT_INTERVAL, dispatch);
      }
    });

const authenticateSignalRConnection = (dispatch: (arg0: any) => any, userID: string) => {
  if (!authenticated && initialised && connection.state === signalR.HubConnectionState.Connected) {
    authenticated = true;
    if (authenticateIntervalID) {
      clearInterval(authenticateIntervalID);
    }
    connection.invoke("Authenticate", userID).catch(() => {
      authenticateIntervalID = setInterval(authenticateSignalRConnection, AUTHENTICATE_INTERVAL, dispatch, userID);
      authenticated = false;
    });
  } else if (!authenticated) {
    authenticateIntervalID = setInterval(authenticateSignalRConnection, AUTHENTICATE_INTERVAL, dispatch, userID);
  }
};

const cplAuthSignalRMiddleware =
  ({ dispatch }: { dispatch: (arg0: any) => any }) =>
  (next: (arg0: { type: string }) => any) =>
  (action: { type: string; payload: any }) => {
    if (!initialised) {
      const protocol = new signalR.JsonHubProtocol();
      const transport = signalR.HttpTransportType.WebSockets | signalR.HttpTransportType.LongPolling;

      const options: signalR.IHttpConnectionOptions = {
        transport,
        logMessageContent: true,
        logger: signalR.LogLevel.Error,
        withCredentials: false,
      };

      connection = new signalR.HubConnectionBuilder()
        .withUrl(`${process.env.REACT_APP_CPL_AUTH_API_BASE_URI}/Notifications`, options)
        .withHubProtocol(protocol)
        .build();

      initialised = true;

      setupCommonSignalRFunctions(connection, dispatch);

      connection.onclose(() => startSignalRConnection(dispatch));

      startSignalRConnection(dispatch);
    }

    if (action.type === actionTypes.SetUser) {
      authenticateSignalRConnection(dispatch, action.payload.user.clientPortalUserID);
    }

    if (action.type === actionTypes.Logout && connection !== undefined && authenticated) {
      connection.stop().then(() => {
        authenticated = false;
      });
    }

    return next(action);
  };

export default cplAuthSignalRMiddleware;
